<header>
    <h1>Ajuda do {{appName}}</h1>
    <button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</header>
<iframe [src]="trustedUrl"></iframe>